import React, { Fragment } from "react";

import { Button as RaButton } from "react-admin";
import { useHistory } from "react-router-dom";

import FileCopyIcon from "@material-ui/icons/FileCopy";

const CloneAllButton = ({
	basePath = "",
	label = "ra.action.clone",
	record,
	...rest
}) => {
	const selectedIds = rest?.selectedIds;
	const history = useHistory(); // Note: history is mutable. This prevents render loops in useCallback.

	const handleClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		history.push({
			pathname: `/bookmaker-deals/create`,
			search: `?source=${encodeURIComponent(
				JSON.stringify({ duplicateIds: selectedIds })
			)}`,
		});
	};

	if (!selectedIds || !selectedIds.length) return null;

	return (
		<Fragment>
			<RaButton label={label} color="secondary" onClick={handleClick}>
				<FileCopyIcon />
			</RaButton>
		</Fragment>
	);
};

export default CloneAllButton;
